<template>
    <div>
        <!-- DISPLAY ONLY IF SLIDE BAR STYLE TYPE SELECTED -->
        <b-row v-show="prop_siteSettingArray.styleType == '7'">
            <!-- Headline1 -->
            <b-col md="12">
                <b-form-group>
                    <label for="slideBarSay1">
                        <h6><strong>Headline1</strong></h6>
                    </label>
                    <b-form-input type="text" name="slideBarSay1" v-model="prop_siteSettingArray.slideBarSay1" placeholder="Check out our latest sale" />
                </b-form-group>
            </b-col>

            <!-- Headline2 -->
            <b-col md="12">
                <b-form-group>
                    <label for="slideBarSay2">
                        <h6><strong>Headline2</strong></h6>
                    </label>
                    <b-form-input type="text" name="slideBarSay2" v-model="prop_siteSettingArray.slideBarSay2" placeholder="Check out our latest sale" />
                </b-form-group>
            </b-col>

            <!-- Headline3 -->
            <b-col md="12">
                <b-form-group>
                    <label for="slideBarSay3">
                        <h6><strong>Headline3</strong></h6>
                    </label>
                    <b-form-input type="text" name="slideBarSay3" v-model="prop_siteSettingArray.slideBarSay3" placeholder="Check out our latest sale" />
                </b-form-group>
            </b-col>

            <!-- Font family -->
            <b-col md="12">
                <b-form-group>
                    <label for="fontFamily">
                        <h6><strong>Font family</strong></h6>
                    </label>
                    <Select2 :options="textFontFamily" name="fontFamily" v-model="prop_siteSettingArray.fontFamily" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- DISPLAY ONLY IF SLIDE BAR STYLE TYPE NOT SELECTED -->
        <b-row v-show="prop_siteSettingArray.styleType != '7'">
            <!-- Headline -->
            <b-col md="12" v-show="prop_siteSettingArray.styleType != '8'">
                <b-form-group>
                    <label for="captureBarSay">
                        <h6><strong>Headline</strong></h6>
                    </label>
                    <b-form-input type="text" name="captureBarSay" v-model="prop_siteSettingArray.captureBarSay" placeholder="Checkout our latest sale" />
                </b-form-group>
            </b-col>

            <!-- Caption -->
            <b-col md="12" v-show="prop_siteSettingArray.styleType != '8'">
                <b-form-group>
                    <label for="captiontext">
                        <h6><strong>Caption</strong></h6>
                    </label>
                    <b-form-input type="text" name="captiontext" v-model="prop_siteSettingArray.captiontext" placeholder="Caption" />
                </b-form-group>
            </b-col>

            <!-- Name Placeholder -->
            <b-col md="12" v-if="prop_siteSettingArray.subGoal == 1 && (prop_siteSettingArray.collectFromVisitors == 2 || prop_siteSettingArray.collectFromVisitors == 3) && prop_siteSettingArray.styleType != '8'">
                <b-form-group>
                    <label for="namePlaceholder">
                        <h6><strong>Name placeholder</strong></h6>
                    </label>
                    <b-form-input type="text" name="namePlaceholder" v-model="prop_siteSettingArray.namePlaceholder" placeholder="Your name" />
                </b-form-group>
            </b-col>

            <!-- Email Placeholder -->
            <b-col md="12" v-if="(prop_siteSettingArray.subGoal == 1 && (prop_siteSettingArray.collectFromVisitors == 1 || prop_siteSettingArray.collectFromVisitors == 2 || prop_siteSettingArray.collectFromVisitors == 4)) && prop_siteSettingArray.styleType != '8'">
                <b-form-group>
                    <label for="emailPlaceholder">
                        <h6><strong>Email placeholder</strong></h6>
                    </label>
                    <b-form-input type="text" name="emailPlaceholder" v-model="prop_siteSettingArray.emailPlaceholder" placeholder="Your email" />
                </b-form-group>
            </b-col>

            <!-- Phone Placeholder -->
            <b-col md="12" v-if="(prop_siteSettingArray.subGoal == 1 && (prop_siteSettingArray.collectFromVisitors == 3 || prop_siteSettingArray.collectFromVisitors == 4)) && prop_siteSettingArray.styleType != '8'">
                <b-form-group>
                    <label for="phoneNumberPlaceholder">
                        <h6><strong>Phone placeholder</strong></h6>
                    </label>
                    <b-form-input type="text" name="phoneNumberPlaceholder" v-model="prop_siteSettingArray.phoneNumberPlaceholder" placeholder="Your phone number" />
                </b-form-group>
            </b-col>

            <!-- START : TWO-STEP POPUP TEXT FIELDS (STYLETYPE 8) -->
            <template v-if="prop_siteSettingArray.styleType == '8'">
                <!-- EMAIL STEP FIELDS -->
                <b-col md="12"><hr><h6 class="text-primary"><strong>Email</strong></h6></b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="first_popup_header_text"><h6><strong>Header text</strong></h6></label>
                        <b-form-input type="text" name="first_popup_header_text" v-model="prop_siteSettingArray.first_popup_header_text" placeholder="Limited Time" maxlength="255" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="captureBarSay"><h6><strong>Headline</strong></h6></label>
                        <b-form-input type="text" name="captureBarSay" v-model="prop_siteSettingArray.captureBarSay" placeholder="10% OFF" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="captiontext"><h6><strong>Caption</strong></h6></label>
                        <b-form-input type="text" name="captiontext" v-model="prop_siteSettingArray.captiontext" placeholder="Handcrafted Tennessee Wines. Delivered to your door." />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="emailPlaceholder"><h6><strong>Email placeholder</strong></h6></label>
                        <b-form-input type="text" name="emailPlaceholder" v-model="prop_siteSettingArray.emailPlaceholder" placeholder="Enter your email" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="buttonSay"><h6><strong>Button text</strong></h6></label>
                        <b-form-input type="text" name="buttonSay" v-model="prop_siteSettingArray.buttonSay" placeholder="Claim My 5%" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="first_popup_footer_text"><h6><strong>Footer text</strong></h6></label>
                        <b-form-input type="text" name="first_popup_footer_text" v-model="prop_siteSettingArray.first_popup_footer_text" placeholder="Add your phone → unlock the full 10%" maxlength="255" />
                    </b-form-group>
                </b-col>

                <!-- PHONE STEP FIELDS -->
                <b-col md="12"><hr><h6 class="text-primary"><strong>Phone</strong></h6></b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="second_popup_header_text"><h6><strong>Header text</strong></h6></label>
                        <b-form-input type="text" name="second_popup_header_text" v-model="prop_siteSettingArray.second_popup_header_text" placeholder="5% Secured" maxlength="255" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="second_popup_headline"><h6><strong>Headline</strong></h6></label>
                        <b-form-input type="text" name="second_popup_headline" v-model="prop_siteSettingArray.second_popup_headline" placeholder="Double Your Savings" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="second_popup_discount_text"><h6><strong>Discount text</strong></h6></label>
                        <b-form-input type="text" name="second_popup_discount_text" v-model="prop_siteSettingArray.second_popup_discount_text" placeholder="+5%" maxlength="255" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="second_popup_caption"><h6><strong>Caption</strong></h6></label>
                        <b-form-input type="text" name="second_popup_caption" v-model="prop_siteSettingArray.second_popup_caption" placeholder="Drop your number. We'll send the full code." />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="phoneNumberPlaceholder"><h6><strong>Phone placeholder</strong></h6></label>
                        <b-form-input type="text" name="phoneNumberPlaceholder" v-model="prop_siteSettingArray.phoneNumberPlaceholder" placeholder="Enter your phone" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="second_popup_button_text"><h6><strong>Button text</strong></h6></label>
                        <b-form-input type="text" name="second_popup_button_text" v-model="prop_siteSettingArray.second_popup_button_text" placeholder="Send My 10% Code" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="second_popup_footer_text"><h6><strong>Footer text</strong></h6></label>
                        <b-form-input type="text" name="second_popup_footer_text" v-model="prop_siteSettingArray.second_popup_footer_text" placeholder="I'll pass on the extra 5%" maxlength="255" />
                    </b-form-group>
                </b-col>
            </template>
            <!-- END : TWO-STEP POPUP TEXT FIELDS -->

            <!-- START : BUTTON 2 -->
            <b-col md="12" v-if="!([5, 7].includes(prop_siteSettingArray.subGoal)) && prop_siteSettingArray.isModalButtonTwo && (isModalButtonTwoShowActive || prop_siteSettingArray.isModalButtonTwo != 0) && (prop_siteSettingArray.styleType == 2 || prop_siteSettingArray.styleType == 6)">
                <b-form-group>
                    <label for="modalButtonTwoSay">
                        <h6><strong>Button 2 text</strong></h6>
                    </label>
                    <b-form-input type="text" name="modalButtonTwoSay" v-model="prop_siteSettingArray.modalButtonTwoSay" placeholder="Button Label" />
                </b-form-group>
            </b-col>
            <b-col md="12" v-if="!([5, 7].includes(prop_siteSettingArray.subGoal)) && prop_siteSettingArray.isModalButtonTwo && (isModalButtonTwoShowActive || prop_siteSettingArray.isModalButtonTwo != 0) && (prop_siteSettingArray.styleType == 2 || prop_siteSettingArray.styleType == 6)">
                <b-form-group>
                    <label for="modalButtonTwoRedirectLink">
                        <h6><strong>Button 2 Redirect Link</strong></h6>
                    </label>
                    <b-form-input type="text" name="modalButtonTwoRedirectLink" v-model="prop_siteSettingArray.modalButtonTwoRedirectLink" placeholder="Redirect Link" />
                </b-form-group>
            </b-col>
            <!-- END : BUTTON 2 -->

            <!-- Button Text (NOT FOR TWO-STEP POPUP) -->
            <b-col md="12" v-show="prop_siteSettingArray.styleType != '8'">
                <b-form-group>
                    <label for="buttonSay">
                        <h6><strong>Button text</strong></h6>
                    </label>
                    <b-form-input type="text" name="buttonSay" v-model="prop_siteSettingArray.buttonSay" placeholder="Button Label" />
                </b-form-group>
            </b-col>

            <!-- COMMON SECTION HEADER FOR TWO-STEP POPUP -->
            <b-col md="12" v-show="prop_siteSettingArray.styleType == '8'"><hr><h6 class="text-primary"><strong>Common</strong></h6></b-col>

            <!-- Font family -->
            <b-col md="12">
                <b-form-group>
                    <label for="fontFamily">
                        <h6><strong>Font family</strong></h6>
                    </label>
                    <Select2 :options="this.textFontFamily" name="fontFamily" v-model="prop_siteSettingArray.fontFamily" />
                </b-form-group>
            </b-col>

            <!-- Font family for button -->
            <b-col md="12">
                <b-form-group>
                    <label for="fontFamilyButton">
                        <h6><strong>Font family for button</strong></h6>
                    </label>
                    <Select2 :options="this.textFontFamilyForButton" name="fontFamilyButton" v-model="prop_siteSettingArray.fontFamilyButton" />
                </b-form-group>
            </b-col>

            <!-- Font family for Input -->
            <b-col md="12">
                <b-form-group>
                    <label for="fontFamilyInput">
                        <h6><strong>Font family for Input</strong></h6>
                    </label>
                    <Select2 :options="this.textFontFamilyForInput" name="fontFamilyInput" v-model="prop_siteSettingArray.fontFamilyInput" />
                </b-form-group>
            </b-col>

            <!-- Side Button Text -->
            <b-col md="12" v-show="prop_siteSettingArray.styleType == '6'">
                <b-form-group>
                    <label for="sideButtonSay">
                        <h6><strong>Side Button text</strong></h6>
                    </label>
                    <b-form-input type="text" name="sideButtonSay" v-model="prop_siteSettingArray.sideButtonSay" placeholder="Side Button Label" />
                </b-form-group>
            </b-col>

            <!-- Font family for Side button -->
            <b-col md="12" v-show="prop_siteSettingArray.styleType == '6'">
                <b-form-group>
                    <label for="fontFamilySideButton">
                        <h6><strong>Font family for side button</strong></h6>
                    </label>
                    <Select2 :options="this.textFontFamilyForInput" name="fontFamilySideButton" v-model="prop_siteSettingArray.fontFamilySideButton" />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { BRow, BCol, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox } from 'bootstrap-vue'
    import captureOptions from "@/libs/capture-Options"

    export default {
        components: {
            BRow, BCol, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox
        },
        name: 'TextsSetting',
        props: {
            prop_siteSettingArray: {
                type: Object,
                default: () => { },
            },
            isModalButtonTwoShowActive: {
                type: Boolean,
                default: false,
            }
        },

        setup() {
            const { textFontFamily, textFontFamilyForButton, textFontFamilyForInput } = captureOptions();
            return {
                textFontFamily, textFontFamilyForButton, textFontFamilyForInput
            }
        },
        created() {
            /** SET DEFAULT FONT-FAMILY WHEN ADD NEW A CAPTURE */
            if (!_.isEmpty(this.prop_siteSettingArray.isModalButtonTwo) && this.prop_siteSettingArray.isModalButtonTwo == 1) {
                this.prop_siteSettingArray.isModalButtonTwo = true;
            }
            if (_.isEmpty(this.prop_siteSettingArray.fontFamily)) {
                this.prop_siteSettingArray.fontFamily = 'Open Sans';
            }
            if (_.isEmpty(this.prop_siteSettingArray.fontFamilyButton)) {
                this.prop_siteSettingArray.fontFamilyButton = 'Open Sans';
            }
            if (_.isEmpty(this.prop_siteSettingArray.fontFamilyInput)) {
                this.prop_siteSettingArray.fontFamilyInput = 'Open Sans';
            }
            if (_.isEmpty(this.prop_siteSettingArray.sideButtonSay)) {
                this.prop_siteSettingArray.sideButtonSay = 'Click here';
            }
            if (_.isEmpty(this.prop_siteSettingArray.fontFamilySideButton)) {
                this.prop_siteSettingArray.fontFamilySideButton = 'Open Sans';
            }
            if (_.isEmpty(this.prop_siteSettingArray.modalButtonTwoSay)) {
                this.prop_siteSettingArray.modalButtonTwoSay = 'Click here';
            }
            /* TWO-STEP POPUP DEFAULT TEXTS (STYLETYPE 8) : START */
            if (this.prop_siteSettingArray.styleType == '8') {
                /* EMAIL STEP (STEP 1) DEFAULT TEXTS */
                if (_.isEmpty(this.prop_siteSettingArray.first_popup_header_text)) {
                    this.prop_siteSettingArray.first_popup_header_text = 'Limited Time';
                }
                if (_.isEmpty(this.prop_siteSettingArray.first_popup_footer_text)) {
                    this.prop_siteSettingArray.first_popup_footer_text = 'Add your phone → unlock the full 10%';
                }
                /* PHONE STEP (STEP 2) DEFAULT TEXTS */
                if (_.isEmpty(this.prop_siteSettingArray.second_popup_header_text)) {
                    this.prop_siteSettingArray.second_popup_header_text = '5% Secured';
                }
                if (_.isEmpty(this.prop_siteSettingArray.second_popup_headline)) {
                    this.prop_siteSettingArray.second_popup_headline = 'Double Your Savings';
                }
                if (_.isEmpty(this.prop_siteSettingArray.second_popup_discount_text)) {
                    this.prop_siteSettingArray.second_popup_discount_text = '+5%';
                }
                if (_.isEmpty(this.prop_siteSettingArray.second_popup_caption)) {
                    this.prop_siteSettingArray.second_popup_caption = 'Drop your number. We\'ll send the full code.';
                }
                if (_.isEmpty(this.prop_siteSettingArray.second_popup_button_text)) {
                    this.prop_siteSettingArray.second_popup_button_text = 'Send My 10% Code';
                }
                if (_.isEmpty(this.prop_siteSettingArray.second_popup_footer_text)) {
                    this.prop_siteSettingArray.second_popup_footer_text = 'I\'ll pass on the extra 5%';
                }
            }
            /* TWO-STEP POPUP DEFAULT TEXTS (STYLETYPE 8) : END */
        }
    }
</script>
<style type="scss">
    input[type='color'] {
        width: 5rem;
    }
</style>